import * as Types from "src/state/_types"
import * as GQL from "src/state/gql/_types"

export const SuperAdminThreadViewSchema: Types.ViewSchemaType<GQL.ThreadFragment> = {
    enums: [
        {
            label: "Status",
            field: "thread_status",
            type: "badge",
            relation_field: "display"
        },
        {
            label: "Type",
            field: "thread_type",
            type: "badge",
            relation_field: "display"
        }
    ],
    fields: [
        {
            label: "Deleted",
            field: "deleted",
            type: "boolean"
        },
        {
            label: "Created At",
            field: "created_at",
            type: "datetime"
        },
        {
            label: "Updated At",
            field: "updated_at",
            type: "datetime"
        }
    ],
    relations: {
        
    }
}